import AbstractRequestTask from "../../AbstractRequestTask";
import Launcher from '../../../apa/Launcher';
import Utils from '../../../../utils/Utils';
import {ENABLE_MODAL_RETRIES} from '../../../RequestManagerConstants';

class UpdateProfileTask extends AbstractRequestTask {

  constructor(params,  version = 'v1') {
    super();
    this.gamification_id = params.gamification_id;
    this.username = params.username;
    this.user_image = params.user_image;
    this.version = version;
  }

  getMethod() {
    return "POST";
  }

  getHeaders() {
    return {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
  }

  getQueryStringParams() {

    const superParams = super.getParams();
    const qsParams = Object.assign({}, superParams, { gamification_id: this.gamification_id });
    delete qsParams.HKS;
    delete qsParams.api_version;
    delete qsParams.user_token;
    return Utils.buildQueryParams(qsParams);

  }

  getParams() {

    const superParams = super.getParams();

    const params = {
      user_token: superParams.user_token,
      firstname: encodeURIComponent(this.username),
      user_image: this.user_image,
    };

    delete params.api_version;
    delete params.HKS;
    return Object.assign({}, params);
  }

  getUrl() {
    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'profile/update';
    return `${protocol}://${server}/${endpoint}/${version}/${apiname}?${this.getQueryStringParams()}`;
  }

  isValid(data) {
    return !(data.errors || data.status === 1 || data.response === 'error');
  }

  success(data, b) {
    this.resolve(data);
  }
  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default UpdateProfileTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/profile/UpdateProfileTask.js